import { FACE_BY_ID } from "~/lib/faces";
import { useFaceSeo } from "~/lib/seo/useSeo";
import { PaginaDisciplina } from "~/ui/PaginaDisciplina";

export function Play() {
  const face = FACE_BY_ID.play;
  useFaceSeo(face);

  return (
    <PaginaDisciplina
      rotulo="Jogos"
      titulo="Jogos em marca grande, publicados nas duas lojas."
      intro="Fui desenvolvedor Unity na Oktagon Games em títulos de franquias conhecidas, com publicação internacional. Do protótipo jogável até a parte que ninguém mostra: build assinada, classificação etária e fila de revisão da loja."
      entrego={[
        {
          titulo: "Jogo mobile inteiro",
          corpo: "Unity ou Unreal, do protótipo jogável à publicação, para iOS e Android.",
        },
        {
          titulo: "Trabalho dentro de marca de terceiro",
          corpo: "Entrega sob guia de marca e aprovação de licenciador, que é o que muda quando o personagem não é seu.",
        },
        {
          titulo: "Interface com peso de jogo",
          corpo: "Animação pesada, partículas e shaders que continuam acessíveis e rodando em aparelho comum.",
        },
      ]}
      publicado={[
        {
          titulo: "Magic: Puzzle Quest",
          marca: "Oktagon Games · 2019",
          corpo: "Combinar peças com RPG na marca Magic: The Gathering, da Wizards of the Coast. Publicado pela D3 Publisher, para iOS e Android.",
          link: "https://play.google.com/store/apps/details?id=com.d3p.olympic",
        },
        {
          titulo: "Doodle Jump Adventure",
          marca: "Oktagon Games · 2019",
          corpo: "Jogo de pulo da franquia da Lima Sky. Saiu das lojas oficiais e segue listado no QooApp.",
          link: "https://m-apps.qoo-app.com/en-US/app/10205",
        },
      ]}
    />
  );
}
